// Adding these enums here but we will have to move this to specs
export enum PaymentErrorCodes {
    AVS_MISMATCH = 43030,
}
